import ContactCard from './contact-card'
export default ContactCard
